export default {
  title: 'Recibir folletos mensuales automáticos',
  status: {
    enabled: 'Activado',
    disabled: 'Desactivado',
  },
  opt_out: {
    on_hint: 'Tu plan de Foodamigos incluye 500 folletos gratuitos al mes. Desactívalo para dejar de recibirlos.',
    off_hint: 'Los folletos automáticos están pausados. Actívalo para reanudar desde la próxima ejecución mensual.',
    confirm_off: {
      title: '¿Desactivar los folletos automáticos?',
      body: 'Al desactivar esto, {{location}} no recibirá folletos automáticos a partir de la próxima ejecución mensual. Los pedidos existentes no se ven afectados.',
      confirm: 'Desactivar',
      cancel: 'Mantener activo',
    },
  },
  approved_design: {
    label: 'Diseño aprobado para folletos mensuales',
    auto_option: 'Automático (el pedido más reciente)',
    flyer_slot: 'Folleto {{slot}}',
    custom: 'Personalizado',
    untitled: 'Sin título',
    invalid_warning:
      'El diseño guardado ya no está disponible. Se usará el folleto pedido más recientemente hasta que selecciones uno nuevo.',
  },
  toasts: {
    failed_to_load: 'Error al cargar la configuración de folletos automáticos',
    failed_to_save: 'Error al guardar los cambios',
    saved: 'Cambios guardados',
  },
};
